import Loader from "Common/Loader";
import useHasPermission from "hooks/useHasPermission";
import { createStoreOpsRole } from "pages/Componets/API_Modal";
import { HttpStatus } from "pages/Core/http-status";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

interface StoreRoleOpsProp {
  reloadDataSource(): void;
}

const CreateStoreOperationModal: React.FC<StoreRoleOpsProp> = ({
  reloadDataSource,
}) => {
  const hasPermission = useHasPermission();
  const [showCreateStoreOpsModal, setShowCreateStoreOpsModal] =
    React.useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    watch,
  } = useForm({ mode: "onChange" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data: any) => {
    try {
      setLoading(true);
      const response: any = await createStoreOpsRole(data);
      if (response.status === HttpStatus.Success) {
        toast.success(response.message);
        reset();
        setShowCreateStoreOpsModal(false);
        reloadDataSource();
      } else {
        toast.error(response.message);
      }
    } catch (error: any) {
      toast.error(error.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // start Html
  return (
    <div>
      {hasPermission("StoreOpsRole.Write") && (
        <button
          onClick={() => {
            setShowCreateStoreOpsModal(true);
            reset();
          }}
          className="btn btn-sm"
          style={{ border: "1px solid #000" }}
          type="button"
        >
          <i className="bi bi-plus-lg"></i> Add Store Ops Role
        </button>
      )}

      {/* create ops store modal */}
      <Modal
        show={showCreateStoreOpsModal}
        onHide={() => {
          setShowCreateStoreOpsModal(false);
          reset();
        }}
        className="fade"
        dialogClassName="modal-dialog-centered"
        backdrop="static"
      >
        <Modal.Header closeButton>Add Ops Store</Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-sm-12">
                <label>
                  Role Name: <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="roleName"
                  {...register("roleName", {
                    required: "Role Name is required",
                    pattern: {
                      value: /^(?!\s)([A-Za-z]+(\s{1,}[A-Za-z]+)*)$/,
                      message:
                        "Only letters and spaces are allowed. No leading or trailing spaces.",
                    },
                  })}
                />
                {errors.roleName && (
                  <span className="text-danger">
                    {String(errors.roleName.message)}
                  </span>
                )}
              </div>
            </div>
            <div className="d-flex justify-content-end  align-items-end mt-4">
              <button
                type="button"
                className="btn add-btn me-1"
                onClick={() => {
                  setShowCreateStoreOpsModal(false);
                  reset();
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Add"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CreateStoreOperationModal;
